/* ==========================================================================
   CUSTOM: Enquire product feature — popup behaviour
   Loaded by snippets/enquire-form-modal.liquid

   Uses Shopify's native contact form. On submit the page posts to /contact
   and reloads to <page>?contact_posted=true — we detect that and re-open the
   popup so the server-rendered "Thank you" message is visible.
   ========================================================================== */
(function () {
  'use strict';

  var modal = document.getElementById('EnquireModal');
  if (!modal) return;

  var form = document.getElementById('EnquireContactForm');
  var productField = modal.querySelector('[data-enquire-product-field]');
  var urlField = modal.querySelector('[data-enquire-url-field]');
  var firstInput = modal.querySelector('input:not([type="hidden"]), textarea');
  var serverMessages = modal.querySelectorAll('.enquire-form__success, .enquire-form__errors');
  var lastFocused = null;

  function setProductFields(title, url) {
    if (productField) productField.value = title || '';
    if (urlField) urlField.value = url || '';
  }

  function hideMessages() {
    for (var i = 0; i < serverMessages.length; i++) {
      serverMessages[i].style.display = 'none';
    }
  }

  // Manual open from an "Enquire Now" button — start a fresh enquiry
  function openForProduct(title, url) {
    hideMessages();
    if (form) form.reset();
    setProductFields(title, url);

    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('enquire-modal-open');

    if (firstInput) {
      try { firstInput.focus({ preventScroll: true }); } catch (e) { firstInput.focus(); }
    }
  }

  // Auto-open after a successful submit — keep the "Thank you" message visible
  function openWithMessage() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('enquire-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('enquire-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Open / close via clicks
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.js-enquire-open');
    if (trigger) {
      event.preventDefault();
      openForProduct(
        trigger.getAttribute('data-enquire-product') || '',
        trigger.getAttribute('data-enquire-url') || ''
      );
      return;
    }

    if (event.target.closest('[data-enquire-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Shopify reloads to ...?contact_posted=true after a successful contact submit.
  // Re-open the popup so the server-rendered success message shows — but NOT on
  // the dedicated Contact page (which has its own form, id="ContactForm").
  var onDedicatedContactPage = document.getElementById('ContactForm');
  if (!onDedicatedContactPage && window.location.search.indexOf('contact_posted=true') !== -1) {
    openWithMessage();
  }
})();
